import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsSmLicenseArrearList from "../created-inner-pages/license-arears-list";
import TmsLicenseArearsCreation from "../creation-inner-pages/tms-arears-creation";
const LicenseArrears = () => {
  const [visible, setVisible] = useState(false);
  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New License Arrear
        </Button>
      </Row>
      <br />
      {!visible && <TmsSmLicenseArrearList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"License Arrear Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsLicenseArearsCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default LicenseArrears;
